import React from "react";

const Chevron = props => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="variantchooser-chevron"
        {...props}
    >
        <path d="M6 9l6 6 6-6" />
    </svg>
);

export default Chevron;
